import React from 'react';
import LocationTemplate from './LocationTemplate';

const KelfordPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Kelford"
      stateName="North Carolina"
      countyName="Bertie"
      zipCodes={["27847"]}
      latitude={36.1912}
      longitude={-77.2219}
      population={238}
      historicalFact="Incorporated in 1905, developed as a railroad town along the Norfolk and Carolina line."
      nearbyTowns={[
        "Aulander, NC",
        "Windsor, NC",
        "Colerain, NC",
        "Scotland Neck, NC",
        "Ahoskie, NC",
        "Rich Square, NC",
        "Powellsville, NC",
        "Lewiston Woodville, NC"
      ]}
    />
  );
};

export default KelfordPage;